import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';

export function* bulkRejectEntrySaga() {
  yield call(SignalingSocket.send, {
    event: 'bulkRejectUserAccess',
  });
}
